import { loginPopupFragment } from "@saleor/fragments/popup";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { Popup, PopupVariables } from "./types/Popup";

const popup = gql`
  ${loginPopupFragment}
  query Popup($after: String, $first: Int, $last: Int, $before: String) {
    loginpopup(before: $before, after: $after, first: $first, last: $last) {
      edges {
        node {
          ...LoginPopupFragment
        }
      }
    }
  }
`;
export const useLoginpopupListQuery = makeQuery<Popup, PopupVariables>(popup);
